import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
import { TranslateModule } from '@ngx-translate/core';
import { CriterionsTabComponent } from './components/criterions-tab/criterions-tab.component';
import { CriterionsTreeComponent } from './components/criterions-tree/criterions-tree.component';
import { SessionsTabComponent } from './components/sessions-tab/sessions-tab.component';
import { TeamMembersComponent } from './components/team-members/team-members.component';
import { ScrollRetainerDirective } from './directives/scroll-retainer.directive';
import { DistributeTeamMembersComponent } from './distribute-team-members.component';
import { DistributeService } from './services/distribute.service';

import { OverlayModule } from '@angular/cdk/overlay';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormioPipesModule } from '../../../shared/pipes';
import { MemberLengthIconComponent } from './components/member-length-icon/member-length-icon.component';
import { LocalizedDatePipe } from './pipes/localized-date.pipe';

const components = [
  DistributeTeamMembersComponent,
  CriterionsTreeComponent,
  TeamMembersComponent,
  ScrollRetainerDirective,
  CriterionsTabComponent,
  SessionsTabComponent,
  LocalizedDatePipe,
  MemberLengthIconComponent,
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    TranslateModule,
    OverlayModule,
    MatTabsModule,
    MatListModule,
    MatButtonModule,
    MatTreeModule,
    MatIconModule,
    MatTooltipModule,
    MatBadgeModule,
    MatCardModule,
    MatChipsModule,
    FormioPipesModule,
  ],
  providers: [DistributeService],
  entryComponents: [DistributeTeamMembersComponent],
  exports: [DistributeTeamMembersComponent],
})
export class DistributeTeamMembersModule {}
